import React from "react";
import NinHero from "./NinHero";
import NinTrustBar from "./NinTrustBar";
import NinBenefits from "./NinBenefits";
import NinHowItWorks from "./NinHowItWorks";
import NinLoginSample from "./NinLoginSample";
import NinCompliance from "./NinCompliance";
import NinCta from "./NinCta";
import Footer from "../../components/Footer/Footer";
import { PageWrapper } from "./NinLanding.elements";
import SEOHelmet from "../../components/SEOHelmet/SEOHelmet";

const ninStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "NIN Verification",
  "serviceType": "Identity Verification",
  "provider": {
    "@type": "Organization",
    "name": "e-citizen",
    "url": "https://e-citizen.ng"
  },
  "description": "Instantly verify any Nigerian National Identification Number (NIN). Get full name, date of birth, and photo ID confirmation in seconds using government-approved data sources.",
  "areaServed": {
    "@type": "Country",
    "name": "Nigeria"
  },
  "url": "https://e-citizen.ng/nin-verification",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "NGN",
    "availability": "https://schema.org/InStock",
    "url": "https://e-citizen.ng/nin-verification"
  }
};

const NinVerificationPage = () => {
  return (
    <PageWrapper>
      <SEOHelmet
        title="NIN Verification Nigeria – Verify Any NIN Online Instantly | e-citizen"
        description="Verify any Nigerian National Identification Number (NIN) online in seconds. Get full name, date of birth, and photo ID confirmation. Secure, fast, and powered by official government data."
        canonical="/nin-verification"
        keywords="NIN verification Nigeria, verify NIN online, National Identification Number check, NIN lookup, ecitizen NIN"
        structuredData={ninStructuredData}
      />
      <NinHero />
      <NinTrustBar />
      <NinBenefits />
      <NinHowItWorks />
      <NinLoginSample />
      <NinCompliance />
      <NinCta />
      <Footer />
    </PageWrapper>
  );
};

export default NinVerificationPage;

